
import { TwoColumnLayout } from '../global'

const SeamlessCuratedExperiencesSection = () => {
  const content = (
    <>
      <div style={{ marginBottom: '24px' }}>
        <h3 style={{
          fontFamily: 'Plus Jakarta Sans, sans-serif',
          fontSize: '16px',
          fontWeight: '600',
          color: '#764F2B',
          marginBottom: '12px'
        }}>
          Consultation
        </h3>
        <p style={{ marginBottom: '16px' }}>
          Begin with a personal consultation to define style preferences, must-haves, and wish-list pieces.
        </p>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <h3 style={{
          fontFamily: 'Plus Jakarta Sans, sans-serif',
          fontSize: '16px',
          fontWeight: '600',
          color: '#764F2B',
          marginBottom: '12px'
        }}>
          Curated Sourcing
        </h3>
        <p style={{ marginBottom: '16px' }}>
          Your personal shopper draws from a private network of global experts and brand insiders to identify exclusive options tailored for you.
        </p>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <h3 style={{
          fontFamily: 'Plus Jakarta Sans, sans-serif',
          fontSize: '16px',
          fontWeight: '600',
          color: '#764F2B',
          marginBottom: '12px'
        }}>
          Exclusive Access
        </h3>
        <p style={{ marginBottom: '16px' }}>
          Discover preview launches, pre-sale opportunities, and invitation-only events curated by your shopping expert.
        </p>
      </div>

      <div>
        <h3 style={{
          fontFamily: 'Plus Jakarta Sans, sans-serif',
          fontSize: '16px',
          fontWeight: '600',
          color: '#764F2B',
          marginBottom: '12px'
        }}>
          End-to-End Handling
        </h3>
        <p>
          From sourcing to secure delivery and aftercare, every detail is meticulously managed - so you enjoy the thrill of acquisition without the stress.
        </p>
      </div>
    </>
  )

  return (
    <TwoColumnLayout
      title="Seamless, Curated Experiences"
      content={content}
      imageSrc="/Bespoke Shopping/Seamless, Curated Experiences.png"
      imageAlt="Seamless, Curated Experiences - Luxury consultation"
      imageFirst={true}
      backgroundColor="#FFFFFF"
      titleColor="#111"
      textColor="#7B7B7B"
      titleSize="40px"
    />
  )
}

export default SeamlessCuratedExperiencesSection